import { api } from '@/apis';
import { log } from '@/utils';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useTag(id) {
  const queryKey = ['tags', id];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: async ({ signal }) => {
      if (id === 'new') {
        return {
          title: '',
        };
      }

      const json = [
        { $match: { identifier: id } },
        {
          $project: {
            identifier: true,
            title: true,
            description: true,
            items: true,
            lastEdit: true,
          },
        },
      ];

      const tags = await api.post('pipeline/tags', { json, signal }).json();

      log('Read', 'Tags', { id });

      return tags[0] ?? null;
    },
    staleTime: 1000 * 60 * 60,
  });

  return {
    query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
